module.exports = __webpack_public_path__ + "img/设置.274f2d3e.png";